import React from "react";
import { Td, Tr } from "react-super-responsive-table";
import {
    CBadge,
    CButton,
    CButtonGroup,
    CCol,
    CFormTextarea,
    CRow,
} from "@coreui/react";
import DateDisplay from "../../components/DisplayData/DateDisplay";
import Helper from "../../application/helper";
import { useSelector } from "react-redux";
import PrintAccountStatmentLink from "../../components/PrintAccountStatmentLink";

const TBodyDesktop = (props) => {
    const { list } = props;
    const auth = useSelector((state) => state.entities.auth);
    return (
        <React.Fragment>
            {list.data !== undefined && list.data[0] === undefined && (
                <Tr>
                    <Td colSpan={8}>
                        Great! You are free of all entities.
                        <div
                            onClick={() => props.add()}
                            style={{
                                cursor: "pointer",
                            }}
                        >
                            Click Me to Make Memo
                        </div>
                    </Td>
                </Tr>
            )}
            {list.data &&
                list.data.map((l) => {
                    return (
                        <Tr key={l.data.id}>
                            <Td scope="row">
                                <CRow>
                                    <CCol>
                                        {l.data.customer_ledger_memo_number}
                                    </CCol>
                                </CRow>
                                {l.data.note && l.data.note.trim() !== "" && (
                                    <CRow>
                                        <CCol>
                                            <CFormTextarea
                                                disabled={true}
                                                defaultValue={l.data.note}
                                                readOnly={true}
                                            />
                                        </CCol>
                                    </CRow>
                                )}
                            </Td>
                            <Td scope="row">
                                <CRow>
                                    <CCol>{l.data.created_by.name}</CCol>
                                </CRow>
                                <CRow>
                                    <CCol>
                                        @
                                        <DateDisplay
                                            options={{
                                                year: "numeric",
                                                month: "numeric",
                                                day: "numeric",
                                            }}
                                        >
                                            {l.data.created_at}
                                        </DateDisplay>
                                    </CCol>
                                </CRow>
                            </Td>
                            <Td scope="row">
                                {l.data.customer_account.name} #
                                {
                                    l.data.customer_account
                                        .customer_account_number
                                }
                                <PrintAccountStatmentLink
                                    customer_account_number={
                                        l.data.customer_account
                                            .customer_account_number
                                    }
                                />
                            </Td>
                            <Td scope="row">{l.data.amount}</Td>
                            <Td scope="row" className={"text-capitalize"}>
                                {l.data.transaction_type}
                            </Td>
                            <Td scope="row">
                                <div>
                                    {!(
                                        l.data.rejected_by !== undefined &&
                                        l.data.rejected_by !== null &&
                                        Object.keys(l.data.rejected_by)
                                            .length !== undefined
                                    ) && (
                                        <>
                                            {l.data.approved_by !== undefined &&
                                                l.data.approved_by !== null &&
                                                Object.keys(l.data.approved_by)
                                                    .length !== undefined && (
                                                    <>
                                                        <CRow
                                                            className={"pb-1"}
                                                        >
                                                            <CCol>
                                                                <CBadge color="success">
                                                                    Approved By
                                                                </CBadge>
                                                            </CCol>
                                                        </CRow>
                                                        <CRow>
                                                            <CCol>
                                                                {
                                                                    l.data
                                                                        .approved_by
                                                                        .name
                                                                }
                                                            </CCol>
                                                        </CRow>
                                                        <CRow>
                                                            <CCol>
                                                                @
                                                                <DateDisplay>
                                                                    {
                                                                        l.data
                                                                            .approved_at
                                                                    }
                                                                </DateDisplay>
                                                            </CCol>
                                                        </CRow>
                                                    </>
                                                )}
                                            {auth.is_admin && (
                                                <>
                                                    {l.data.approved_by ===
                                                        null &&
                                                        l.data
                                                            .customer_ledger_id ==
                                                            null && (
                                                            <>
                                                                <CButton
                                                                    size={"sm"}
                                                                    className={
                                                                        "mb-1"
                                                                    }
                                                                    color="success"
                                                                    onClick={() => {
                                                                        window.location.href =
                                                                            Helper.route(
                                                                                "customer-ledger-memo.approve",
                                                                                {
                                                                                    customer_ledger_memo:
                                                                                        l
                                                                                            .data
                                                                                            .id,
                                                                                }
                                                                            );
                                                                    }}
                                                                >
                                                                    Please
                                                                    Approve
                                                                </CButton>
                                                            </>
                                                        )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                                <div>
                                    {l.data.rejected_by !== undefined &&
                                        l.data.rejected_by !== null &&
                                        Object.keys(l.data.rejected_by)
                                            .length !== undefined && (
                                            <>
                                                <CRow className={"pb-1"}>
                                                    <CCol>
                                                        <CBadge color="danger">
                                                            Rejected By
                                                        </CBadge>
                                                    </CCol>
                                                </CRow>
                                                <CRow>
                                                    <CCol>
                                                        {
                                                            l.data.rejected_by
                                                                .name
                                                        }
                                                    </CCol>
                                                </CRow>
                                                <CRow>
                                                    <CCol>
                                                        @
                                                        <DateDisplay>
                                                            {l.data.rejected_at}
                                                        </DateDisplay>
                                                    </CCol>
                                                </CRow>
                                            </>
                                        )}
                                    {auth.is_admin && (
                                        <>
                                            {l.data.rejected_by === null &&
                                                l.data.customer_ledger_id ==
                                                    null && (
                                                    <>
                                                        <CButton
                                                            size={"sm"}
                                                            color="warning"
                                                            onClick={() => {
                                                                window.location.href =
                                                                    Helper.route(
                                                                        "customer-ledger-memo.reject",
                                                                        {
                                                                            customer_ledger_memo:
                                                                                l
                                                                                    .data
                                                                                    .id,
                                                                        }
                                                                    );
                                                            }}
                                                        >
                                                            In worst case Reject
                                                        </CButton>
                                                    </>
                                                )}
                                        </>
                                    )}
                                </div>
                            </Td>
                            <Td>
                                <CButtonGroup
                                    role="group"
                                    aria-label="Basic mixed styles example"
                                >
                                    <CButton
                                        size={"sm"}
                                        color="info"
                                        onClick={() => {
                                            window.location.href = Helper.route(
                                                "customer-ledger-memo.show",
                                                {
                                                    customer_ledger_memo:
                                                        l.data.id,
                                                }
                                            );
                                        }}
                                    >
                                        {!l.data.customer_ledger_id &&
                                            !(
                                                l.data.rejected_by !==
                                                    undefined &&
                                                l.data.rejected_by !== null &&
                                                Object.keys(l.data.rejected_by)
                                                    .length !== undefined
                                            ) && <>Edit</>}
                                        {(l.data.customer_ledger_id ||
                                            (l.data.rejected_by !== undefined &&
                                                l.data.rejected_by !== null &&
                                                Object.keys(l.data.rejected_by)
                                                    .length !== undefined)) && (
                                            <>Open Memo</>
                                        )}
                                    </CButton>
                                    {!l.data.customer_ledger_id &&
                                        !(
                                            l.data.rejected_by !== undefined &&
                                            l.data.rejected_by !== null &&
                                            Object.keys(l.data.rejected_by)
                                                .length !== undefined
                                        ) && (
                                            <CButton
                                                size={"sm"}
                                                color="danger"
                                                onClick={() => {
                                                    window.location.href =
                                                        Helper.route(
                                                            "customer-ledger-memo.delete",
                                                            {
                                                                customer_ledger_memo:
                                                                    l.data.id,
                                                            }
                                                        );
                                                }}
                                            >
                                                Delete
                                            </CButton>
                                        )}
                                </CButtonGroup>
                            </Td>
                        </Tr>
                    );
                })}
        </React.Fragment>
    );
};

export default TBodyDesktop;
